import React, { Component, useState, useEffect } from 'react';
import HeaderPage from '../../Components/HeaderPages';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Spinner  } from "react-awesome-spinners";
import Aviso from '../../Components/Aviso';
import CaixaInforme from '../../Components/CaixaInforme';
import Butao from '../../Components/Butao_list';
import Select from '../../Components/Select';
import Campo from '../../Components/Campo';
import TextArea from '../../Components/TextArea';
import Pagination from '../../Components/Pagination';
import CriarGrupo from './TACriarGrupo';
import EditarGrupo from './EditarGrupo';
import Api from '../../Api';



export default ({InfIdConta, InfIdUse, IdConta,  Dados, DadCont, IdUse,setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo,
   setAlertTipo, Avisando, setAvisando}) => {
     const [Pag1, setPag1] = useState(false);
      const [Pag2, setPag2] = useState(false);
      const [Titulo, setTitulo] = useState("Avisos");
      const [Carreg, setCarreg] = useState(false);
      const [Msg, setMsg] = useState("Digite um Aviso para o Sistema Treino App...");
      const [MsgApp, setMsgApp] = useState("Digite um Aviso para o Aplicativo do Aluno...");
      const [AtivoMsg, setAtivoMsg] = useState(false);
      const [AtivoMsgApp, setAtivoMsgApp] = useState(false);

      
      useEffect(() => {
        if(InfIdConta && Object.keys(InfIdConta).length > 0){
         Preencher()
        }        
            }, [InfIdConta])
     
       const Preencher = async ()=>{
        setMsgApp(InfIdConta.MensagemApp.Msg)
        setMsg(InfIdConta.MensagemSistem.Msg)
        setAtivoMsg(InfIdConta.MensagemSistem.Ativo)
        setAtivoMsgApp(InfIdConta.MensagemApp.Ativo)
       }

     
       const CriandoTelefone = async ()=>{
        if(MsgApp){

        if (navigator.onLine) {
         setCarreg(true);
          //await Api.TelefoneCriar(Dados, Telefone, setAlert, setAlertTipo);
         
        } else {
          setAlert("Sem Internet");
          setAlertTipo("danger");
        }
    } else {
        setAlert("Campos Vazios!");
        setAlertTipo("danger");
    }
           
      }
  
     
      
        

                const Desativar = async ()=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                
                //await Api.DesativandoTelefone(Dados, Id, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

                const AtivarMsgApp = async ()=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                
                await Api.TAAtivarMsgApp(IdUse,  InfIdUse, IdConta, MsgApp, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }
                const DesativarMsgApp = async ()=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                
                await Api.TADesativarMsgApp(IdUse,  InfIdUse, IdConta, MsgApp, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

              const AtivarMsgSistem = async ()=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                
                await Api.TAAtivarMsgSistem(IdUse,  InfIdUse, IdConta, Msg, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }
                 const DesativarMsgSistem = async ()=>{
                 
                  setAlert(" ");
                  setAlertTipo(" ");
       
              if (navigator.onLine) {
                
                await Api.TADesativarMsgSistem(IdUse,  InfIdUse, IdConta, Msg, setAlertTipo, setAlert);

                
               } else {
                 setAlert("Sem Internet");
                 setAlertTipo("danger");
               }


                }

          function confirma() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
           
          }
          function cancelar() {
            setAlert(" ");
            setAlertTipo(" ");
            setPag2(false);
            setPag1(false);
          }   

              

              

               

    
      
  return (
        
          <div>
            {Alert !== " " && AlertTipo === "success" &&
                <SweetAlert  success title={Alert} onConfirm={confirma} onCancel={cancelar} />
              }

           
            { Pag1 === false ?
            <div className="content-wrapper">
               
              <HeaderPage
              Avisando={Avisando} 
              Titulo={Titulo}
              /> 
                         
              <section className="content">
                <div className="container-fluid">
                  
                <div className="row">
                  <section className="col-12">
                  {Loading === true ?
                        <Spinner 
                        size={64}
                        color={"#5d0bf7"}
                        sizeUnit={'px'} 
                        />
                        :
                        <>
                        
 {/* general form elements disabled */}
 {

 }
        {InfIdConta && Object.keys(InfIdConta).length > 0 &&
        <>
        {InfIdConta.MensagemSistem.Ativo &&
      <div class="alert alert-warning alert-dismissible">
              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
              {InfIdConta.MensagemSistem.Msg}
            </div>
        }
        </>   
        }
        {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.TempLimitAtiv < new Date().getTime() &&
                      <div class="alert alert-danger alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                             A mensalidade da sua conta vence em {new Date(InfIdConta.TempLimitAtiv).toLocaleDateString('pt-BR')}. Entre em contato com a empresa e realize o pagamento. Caso o pagamento não seja efetuado em até 5 dias após o vencimento, os aplicativos dos seus alunos serão bloqueados. 
                            </div>
                        }
                        </>   
                        }
  
<div className="card card-warning">
  <div className="card-header">
    <h3 className="card-title">Criar Avisos Para o Sistema do Funcionário </h3>
  </div>
  {/* /.card-header */}
  <div className="card-body">
    
      <div className="row">
        
        <div className="col-sm-6">
          {/* textarea */}
          <div className="form-group">
           
            {AtivoMsg ?
            <>
            <label>Mensagem</label>
            <br/>
            <string>{Msg}</string>
            </>
            : 
            <>
             <label>Digite a Mensagem</label>
            <TextArea 
            placeholder={Msg}
            value={Msg}
            onChange={e=>setMsg(e.target.value)}
            />
            </>
            }
            </div>
          { AtivoMsg === true ?
                 <>
                {Dados &&
                <>
              {Dados.Avisos.Btn.botão_DesativarMsgSist &&
              <>
               <Butao 
                    style={"btn btn-sm btn-secondary"}
                    titulo={"Desativar"}
                    onClick={()=>DesativarMsgSistem()}
                    />
                    </>
                    }
                    </>
                    }
                   
                 
                   </>
                    :
                    <>
                       {Dados &&
                <>
                {Dados.Avisos.Btn.botão_AtivarMsgSist &&
                 <>
                  <Butao 
                    style={"btn btn-sm btn-warning"}
                    titulo={"Ativar"}
                    onClick={()=>AtivarMsgSistem()}
                    />
                    </>
                    }
                    </>
                    }
                   
                      
                    </>
                 } 
        </div>
        
      </div>
    
  </div>
  {/* /.card-body */}
</div>
   


<div className="card card-success">
  <div className="card-header">
    <h3 className="card-title">Criar Avisos Para o Aplicativo do Aluno</h3>
  </div>
  {/* /.card-header */}
  <div className="card-body">
    
      <div className="row">
        <div className="col-sm-6">
          {/* textarea */}
          <div className="form-group">
            
            {AtivoMsgApp?
            <>
            <label>Mensagem</label>
            <br/>
            <string>{MsgApp}</string>
            </>
            :
            <> 
            <label>Digite a Mensagem</label>
            <TextArea 
            placeholder={MsgApp}
            value={MsgApp}
            onChange={e=>setMsgApp(e.target.value)}
            />
            </>
             }
            </div>
              { AtivoMsgApp === true ?
                 <>
                {Dados &&
                <>
              {Dados.Avisos.Btn.botão_DesativarMsgApp &&
              <>
               <Butao 
                    style={"btn btn-sm btn-secondary"}
                    titulo={"Desativar"}
                    onClick={()=>DesativarMsgApp()}
                    />
                    </>
                    }
                    </>
                    }
                   
                 
                   </>
                    :
                    <>
                      {Dados &&
                <>
                  {Dados.Avisos.Btn.botão_AtivarMsgApp &&
                  <>
                   <Butao 
                    style={"btn btn-sm btn-warning"}
                    titulo={"Ativar"}
                    onClick={()=>AtivarMsgApp()}
                    />
                    </>
                    }
                    </>
                    }
                    
                      
                    </>
                 } 
        </div>
        
      </div>
    
  </div>
  {/* /.card-body */}
</div>
   
                  
                    
                    
                        </>
                        }
                    </section>       
               </div>
            </div>
          </section>
        </div>
        :
        <>
        {Pag2 === false ?
         <>
         </>
          :
          <>
          </>
        }
        </>
        
         }
      </div>

        );
    }

